exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".back-btn {\n  position: absolute !important;\n  top: 12px;\n  background: transparent;\n  margin-left: 15px;\n  z-index: 3; }\n\n.searchBoxStyles {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 1px solid transparent;\n  width: 91.1%;\n  height: 45px;\n  margin-top: 48px;\n  padding: 0 12px 0 12px;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n  font-size: 16px;\n  outline: none;\n  -o-text-overflow: ellipses;\n     text-overflow: ellipses;\n  padding-left: 30px;\n  font-family: Roboto;\n  letter-spacing: 0px;\n  text-align: left;\n  color: #484848;\n  padding-left: 48px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/TrackLocation/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/TrackLocation/index.css
// module chunks = 504